import { getURLParam, request } from '@vfde-fe/sails_core';
import { getCookie } from '@vfde-fe/utils';
import { FNF_COOKIE_NAME, FNF_VALIDATION_PARAM, FNF_URL_PARAM, FNF_VALIDATION_URL } from 'Constant';

export const getHashcode = () => {
    return getURLParam(FNF_URL_PARAM) || getCookie(FNF_COOKIE_NAME);
};

export const validateHashcode = (hashcode: string) => {
    const url = new URL(FNF_VALIDATION_URL);
    url.searchParams.append(FNF_VALIDATION_PARAM, hashcode);

    const options = {
        method: 'GET',
    };

    return request(url.toString(), options);
};
